import React, { useEffect, useState } from "react";
import {
	Button,
	Dropdown,
	DropdownButton,
	Modal,
	Col,
	Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import { ChevronDown } from "react-feather";
import DataTable from "react-data-table-component";
import defaultImage from "../../../src/assets/images/Default_user_image.png";
import moment from "moment";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import PreviewSharpIcon from "@mui/icons-material/PreviewSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Flatpickr from "react-flatpickr";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import LoopSharpIcon from "@mui/icons-material/LoopSharp";
import VerticalAlignBottomSharpIcon from "@mui/icons-material/VerticalAlignBottomSharp";
import ClearSharpIcon from "@mui/icons-material/ClearSharp";
import PeopleSharpIcon from "@mui/icons-material/PeopleSharp";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import HistorySharpIcon from "@mui/icons-material/HistorySharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import DoneIcon from "@mui/icons-material/Done";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import PauseCircleFilledIcon from "@mui/icons-material/PauseCircleFilled";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';

const RecentAplicants = ({ userType }) => {
	const [jobApplications, setJobApplications] = useState([]);
	const sessionId = localStorage.getItem("sessionId");

	const [instituteId, setInstituteId] = useState("");
	const [instituteAppData, setInstituteAppData] = useState(""); 


	const [currentPage, setCurrentPage] = useState(0);
	const [candidateList, setCandidateList] = useState([]);
	const [candidateListData, setCandidateListData] = useState(""); 

	// ..................................................................................
	// Schedule Details
	const [showAppliedModal, setShowAppliedModal] = useState(false);

	// Handlers to open and close the modal
	const handleShowModal = () => setShowAppliedModal(true);
	const handleCloseModal = () => setShowAppliedModal(false);

	const [showAppliedModalScheule, setShowAppliedModalScheule] = useState(false);

	// Handlers to open and close the modal
	const handleShowModalScheule = () => setShowAppliedModal(true);
	const handleCloseModalScheule = () => setShowAppliedModalScheule(false);
	const [showInstModal, setShowInstModal] = useState(false);

	// Handlers to open and close the modal
	const handleInstModal = () => setShowInstModal(true);
	const handleCloseInstModal = () => setShowInstModal(false);
	// ..................................................................................
	// ..................................................................................
	// User Info
	const [showUserInfo, setUserInfo] = useState(false);
	const handleShowInfo = () => setUserInfo(true);
	const handleCloseInfo = () => setUserInfo(false);
	// ..................................................................................

	const [showCancelModal, setShowCancelModal] = useState(false); // State for cancel modal

	// Function to handle cancel action
	const handleCancel = () => {
		setShowCancelModal(true); // Show confirmation modal
	};

	// Function to close the modal
	const handleCloseCancelModal = () => {
		setShowCancelModal(false); // Close confirmation modal
	};

	const [showRejectModal, setShowRejectModal] = useState(false); // State for cancel modal

	// Function to handle cancel action
	const handleReject = () => {
		setShowRejectModal(true); // Show confirmation modal
	};

	// Function to close the modal
	const handleCloseRejectModal = () => {
		setShowRejectModal(false); // Close confirmation modal
	};
	// ...............................................GetAll ...........................................
	const JobAppGetAll = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				pageNumber: 1,
				pageSize: 10,
			};

			const response = await axios.post("/JobApplication/GetAll", requestBody);
			// console.log("responseGetAll", response);

			setCandidateList(response.data.responseData.jobApplications);

		} catch (error) {
			console.error("API Error:", error);
		}
	};

	useEffect(() => {
		JobAppGetAll();
	}, []);

	// ...............................................Institute Candidate HiringStatus ...........................................

	const [hiringStatuses, setHiringStatuses] = useState({});
	const [hiringStatusvalue, setHiringStatusvalue] = useState({});
	const [candData, setCandData] = useState("");

	// ...............................................GetInfo...........................................

	const [jobAppId, setjobAppId] = useState(0); 

	const [jobAppInfoData, setJobAppInfoData] = useState("");
	const [candidateId, setCandidateId] = useState("");
	const getJobAppInfo = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
			};

			const response = await axios.post("/JobApplication/GetInfo", requestBody);
			setJobAppInfoData(response.data.responseData); 

		} catch (error) {
			console.error("API Error:", error);
		}
	};


	// ...............................................RejectApllication...........................................
	const RejectApplication = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
				hiringStatus: "Rejected",
				remark: "",
			}; 
			const response = await axios.post(
				"/JobApplication/UpdateHiringStatus",
				requestBody
			);
			// console.log("UpdateHiringStatus", response);

			toast.success(response.data.message);
			setJobAppInfoData(response.data);
			JobAppGetAll();
			handleCloseCancelModal();
		} catch (error) {
			console.error("API Error:", error);
			toast.error(error);
		}
	};

	// ...............................................Hold ...........................................

	const HoldApplication = async (cnddtId) => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: instituteAppData.jbApplctnId,
				hiringStatus: "Hold",
				remark: "",
				insttUid: instituteAppData.userUid,
				cnddtID: cnddtId,
				grpTypName: instituteAppData.grpTypName,
				grpTypeId: instituteAppData.grpTypeId,
			}; 

			const response = await axios.post(
				"/JobApplication/UpdateHiringStatusForInstituteCandidates",
				requestBody
			);
			toast.success(response.data.message);
			setJobAppInfoData(response.data);
			getGetAllCandidate();
		} catch (error) {
			console.error("API Error:", error);
			toast.error(error);
		}
	};

	// ...............................................UnHold ...........................................

	const UnHoldApplication = async (cnddtId) => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: instituteAppData.jbApplctnId,
				hiringStatus: "Unhold",
				remark: "",
				insttUid: instituteAppData.userUid,
				cnddtID: cnddtId,
				grpTypName: instituteAppData.grpTypName,
				grpTypeId: instituteAppData.grpTypeId,
			}; 

			const response = await axios.post(
				"/JobApplication/UpdateHiringStatusForInstituteCandidates",
				requestBody
			); 

			toast.success(response.data.message);
			setJobAppInfoData(response.data);
			getGetAllCandidate();
		} catch (error) {
			console.error("API Error:", error);
			toast.error(error);
		}
	};

	// ...................................................AcceptApplication..........................................

	const AcceptApplication = async (id) => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: id,
				hiringStatus: "Shortlisted",
				remark: "",
			};


			const response = await axios.post(
				"/JobApplication/UpdateHiringStatus",
				requestBody
			);

			toast.success(response.data.message);
			JobAppGetAll();
		} catch (error) {
			toast.error("Some problem occurred!");
			console.error("API Error:", error);
		}
	};
	// ...................................................AcceptApplicationAsInstitute..........................................

	const AcceptApplicationAsInst = async (cnddtId) => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: instituteAppData.jbApplctnId,
				hiringStatus: "Shortlisted",
				remark: "",
				insttUid: instituteAppData.userUid,
				cnddtID: cnddtId,
				grpTypName: instituteAppData.grpTypName,
				grpTypeId: instituteAppData.grpTypeId,
			};

			const response = await axios.post(
				"/JobApplication/UpdateHiringStatusForInstituteCandidates",
				requestBody
			);

			toast.success(response.data.message);
			JobAppGetAll();
			InstituteCandidateHiringStatus(candData);
		} catch (error) {
			toast.error(error.response);
			console.error("API Error:", error);
		}
	};

	// ...............................................RejectApplicationAsInst...........................................
	const RejectApplicationAsInst = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: instituteAppData.jbApplctnId,
				hiringStatus: "Rejected",
				remark: "",
				insttUid: instituteAppData.userUid,
				cnddtID: candidateId,
				grpTypName: instituteAppData.grpTypName,
				grpTypeId: instituteAppData.grpTypeId,
			};
			const response = await axios.post(
				"/JobApplication/UpdateHiringStatusForInstituteCandidates",
				requestBody
			);

			setJobAppInfoData(response.data);
			handleCloseRejectModal();
			InstituteCandidateHiringStatus(candData);
			toast.success(response.data.message);
		} catch (error) {
			console.error("API Error:", error);
		}
	};

	// ...................................................ScheduleInterview..........................................

	const [scheduleTime, setScheduleTime] = useState("");
	const [placeType, setPlaceType] = useState(0);
	const [placeDetails, setPlaceDetails] = useState("");
	const [remark, setRemark] = useState("");

	const ScheduleInterview = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: jobAppId,
				scheduleTime,
				placeType: parseInt(placeType, 10), // Ensure it's a number
				placeDetails,
				remark,
			};


			const response = await axios.post(
				"/JobApplication/ScheduleInterview",
				requestBody
			);
			console.log("requestBody", requestBody);

			toast.success("Interview Scheduled Successfully!");
			JobAppGetAll();
			handleCloseModal(); // Close modal on success
			setScheduleTime(null);
			setPlaceType("");
			setPlaceDetails("");
			setRemark("");
		} catch (error) {
			toast.error("Some problem occurred!");
			console.error("API Error:", error);
		}
	};

	const ScheduleInterviewAsInst = async () => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: instituteAppData.jbApplctnId,
				scheduleTime,
				placeType: parseInt(placeType, 10), // Ensure it's a number
				placeDetails,
				remark,
				insttUid: instituteAppData.userUid,
				cnddtID: candidateId,
				grpTypName: instituteAppData.grpTypName,
				grpTypeId: instituteAppData.grpTypeId,
			};

			const response = await axios.post(
				"/JobApplication/ScheduleInterviewForInstituteCandidates",
				requestBody
			);

			// toast.success(response.data.message)
			toast.success("Interview Scheduled Successfully!");
			JobAppGetAll();
			handleCloseModal(); // Close modal on success
			handleCloseModalScheule();
			setScheduleTime("");
			setPlaceType(null);
			setPlaceDetails("");
			setRemark("");
			InstituteCandidateHiringStatus(candData);
		} catch (error) {
			toast.error("Some problem occurred!");
			console.error("API Error:", error);
		}
	};

	// ...............................................................................................................

	// ........................................Job History start..........................

	const [jobHistory, setJobHistory] = useState("");
	const [showHistoryModal, setShowHistoryModal] = useState(false);
	const handleHistoryShow = () => setShowHistoryModal(true);
	const handleCloseHistoryModal = () => setShowHistoryModal(false);

	const JobHistory = async (id) => {
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
		};
		console.log("data22", data);
		try {
			await axios.post("/JobApplication/GetHistory", data).then((resData) => {
				console.log("HISTORY", resData.data.responseData);
				const data = resData.data.responseData;
				setJobHistory(data);
			});
		} catch (e) {
			console.log("Unapply ");
		}
	};

	// ........................................Job History End..........................

	// ........................................Job info start..........................

	const [jobInfo, setJobInfo] = useState("");
	const [showInfoModal, setShowInfoModal] = useState(false);
	const handleInfoShow = () => setShowInfoModal(true);
	const handleCloseInfoModal = () => setShowInfoModal(false);

	const JobInfoData = async (id) => {
		const data = {
			sessionId: sessionId,
			jbApplctnId: id,
		};
		// console.log("data22", data);
		try {
			await axios.post("/JobApplication/GetInfo", data).then((resData) => {
				console.log("Info job", resData.data.responseData);
				const data = resData.data.responseData;
				setJobInfo(data);
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.warning(e.response.data.message);
				console.log("Unapply ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};

	// ........................................Job Info End..........................


	const columns = [
		{
			name: "CANDIDATES",
			sortable: true,
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
					{/* Row for Image and Username */}
					<div
						style={{
							display: "flex",
							alignItems: "center",
							flexDirection: "column",
							gap: "10px",
						}}
					>
						{/* User Image */}
						<img
							src={row.userProfilePic}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
						<div
							className="pointer"
						>
							{row.userName}
						</div>
					</div>

					<div className="job-footer-left">
						<ul className="job-tag" style={{ margin: 0, padding: 0 }}>
							<li>
								<a href="/#">{row.jbApplctnTypeName}</a>
							</li>
						</ul>
					</div>
					<div className="pointer">
						{moment(row.appliedTime).format("YYYY-MM-DD")}
					</div>
				</div>
			),
		},
		{
			name: "JOB DETAILS",
			// center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<div className="pointer jobinfo f-600"

							onClick={() => {
								handleInfoShow();
								JobInfoData(row.jbApplctnId)
							}}
						>{row.jobTitle} <span>

							</span>
						</div>
					</div>
					<div className="pointer">{row.shortDescription}</div>
				</div>
			),
			// selector: (row) => row.jobTitle,
		},
		{
			name: "STATUS",
			// center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<>
					{row.jbApplctnType === 2 ? (
						row.hiringStatus === 9 ? (
							<div className="job-footer-left">
								<ul style={{ margin: 0, padding: 0 }}>
									<li>
										<a href="#">{row.hiringStatusName}</a>
									</li>
								</ul>
							</div>
						) : (
							<div className="job-footer-left">
								<ul className="green" style={{ margin: 0, padding: 0 }}>
									<li>
										<a href="#">{row.hiringStatusName}</a>
									</li>
								</ul>
							</div>
						)
					) : (
						<div
							style={{ display: "flex", flexDirection: "column", gap: "5px" }}
						>
							{row.hiringStatus === 1 ? (
								<div className="job-footer-left">
									<ul style={{ margin: 0, padding: 0 }}>
										<li>
											<a href="#">{row.hiringStatusName}</a>
										</li>
									</ul>
								</div>
							) : row.hiringStatus === 5 ? (
								<div className="job-footer-left">
									<ul className="orange" style={{ margin: 0, padding: 0 }}>
										<li>
											<a href="#">{row.hiringStatusName}</a>
										</li>
									</ul>
								</div>
							) : row.hiringStatus === 7 || row.hiringStatus === 8 ? (
								<div className="job-footer-left">
									<ul className="red" style={{ margin: 0, padding: 0 }}>
										<li>
											<a href="#">{row.hiringStatusName}</a>
										</li>
									</ul>
								</div>
							) : (
								<div className="job-footer-left">
									<ul className="green" style={{ margin: 0, padding: 0 }}>
										<li>
											<a href="#">{row.hiringStatusName}</a>
										</li>
									</ul>
								</div>
							)}
						</div>
					)}

					<span className="ms-2">
						<Tooltip title="History" arrow>
							<HistorySharpIcon
								onClick={() => {
									handleHistoryShow();
									JobHistory(row.jbApplctnId);
								}}
								className="pointer"
							/>
						</Tooltip>
					</span>
				</>
			),
		},
		{
			name: "ACTION",
			center: true,
			// minWidth: "300px",
			cell: (row) => (
				<>
					{row.jbApplctnType === 2 ? (
						<Tooltip title="Candidate List" arrow>
							<PeopleSharpIcon
								className="pointer blueIcon"
								onClick={() => {
									setInstituteId(row.userUid);
									setInstituteAppData(row);
									setTimeout(() => {
										handleInstModal();
									}, 100);
								}}
							/>
						</Tooltip>
					) : (
						<div>
							{row.hiringStatus === 7 ||
								row.hiringStatus === 6 ||
								row.hiringStatus === 5 ||
								row.hiringStatus === 8 ? (
								""
							) : (
								<>
									{row?.hiringStatus === 4 ? (
										<span className="me-2">
											<Tooltip title="Schedule" arrow>
												<CalendarMonthSharpIcon
													className="pointer calendarIcon"
													onClick={() => {
														handleShowModal();
														setjobAppId(row.jbApplctnId);
													}}
												/>
											</Tooltip>
										</span>
									) : (
										<span className="me-2">
											<Tooltip title="Shortlist" arrow>
												<CheckSharpIcon
													className="pointer checkIcon"
													onClick={() => {
														AcceptApplication(row.jbApplctnId);
														// setjobAppId(row.jbApplctnId);
													}}
												/>
											</Tooltip>
										</span>
									)}

									<Tooltip title="Reject" arrow>
										<ClearSharpIcon
											className="pointer rejectIcon"
											onClick={() => {
												handleCancel();
												setjobAppId(row.jbApplctnId);
											}}
										/>
									</Tooltip>

									<span className="ms-2 ">
										<Tooltip title="Reseume View" arrow>
											<Link
												target="blank"
												to={`/Resume?userUID=${row.userUid}`}
											>
												<VisibilitySharpIcon className="blueIcon"
												/>
											</Link>
										</Tooltip>
									</span>

									<span className="ms-2 ">
										<Tooltip title="Test Assign" arrow>
											<Link
											>
												<AssignmentSharpIcon
													onClick={() => {
														handleTestShow()
													}}
													className="blueIcon" />
											</Link>
										</Tooltip>
									</span>
								</>
							)}
						</div>
					)}
				</>
			),
		},
	];

	// ..............................................Institute Interview actions.................................................................

	const [showModal, setShowRemarkModal] = useState(false);
	const handleShowRemark = () => setShowRemarkModal(true);
	const handleCloseRemark = () => setShowRemarkModal(false);
	const [updateRemark, setUpdateRemark] = useState("");

	const [showtestModal, setShowTestModal] = useState(false);
	const handleTestShow = () => setShowTestModal(true);
	const handleCloseTestModal = () => setShowTestModal(false);


	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const handleCancelConfirm = () => {
		setShowConfirmationModal(false);
	};

	const [applicationStatus, setApplicationStatus] = useState("");
	 
	const AcceptInterviewApplicationAsInst = async (id, hiringStatus) => {
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: id,
				hiringStatus: hiringStatus,
				remark: "",
				insttUid: instituteAppData.userUid,
				cnddtID: candidateId,
				grpTypName: instituteAppData.grpTypName,
				grpTypeId: instituteAppData.grpTypeId,
			};
			console.log("AcceptApplication", requestBody);
	
			const response = await axios.post(
				"/JobApplication/UpdateHiringStatusForInstituteCandidates",
				requestBody
			);
	
			console.log("getAcceptApplication", response);
			toast.success(response.data.message);
	
			// Update the local state with the new hiring status
			setInstituteAppData((prevData) => ({
				...prevData,
				hiringStatus: hiringStatus,
			}));
	
			// Refresh job applications list
			JobAppGetAll();
			
			// Call the function to refresh the candidate hiring status if needed
			InstituteCandidateHiringStatus(instituteAppData);
			
			handleCancelConfirm();
		} catch (error) {
			toast.error(error.response);
			console.error("API Error:", error);
		}
	};
	
	const Inscolumns = [
		{
			name: "CANDIDATES",
			center: true,
			sortable: true,
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div
						style={{ display: "flex", alignItems: "center", gap: "10px" }}
						className="inst-cacndidate-list-style"
					>
						<img
							src={row.profileImage}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>

						<div className="pointer">{row.firstName}</div>
					</div>

					<div className="pointer ms-5">{row.lastName}</div>
				</div>
			),
		},
		{
			name: "CLASS NAME",
			// center: true,
			sortable: true,
			// minWidth: "150px",
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<div className="pointer">{row.insttClssName}</div>
					</div>
				</div>
			),
		},
		{
			name: "BATCH NAME",
			// center: true,
			sortable: true,
			// minWidth: "150px",
			selector: (row) =>
				Array.isArray(row.batchNames)
					? row.batchNames.join(", ")
					: row.batchNames,
		},
		{
			name: "STATUS",
			sortable: true,
			cell: (row) => {
				const statusValue = hiringStatusvalue[row.cnddtId];
				const statusText = hiringStatuses[row.cnddtId] || "Unknown";

				let badgeClass = "green";
				if (statusValue === 1) {
					badgeClass = "default";
				} else if (statusValue === 5) {
					badgeClass = "orange";
				} else if (statusValue === 0) {
					badgeClass = "red";
				}

				return (
					<div className={`job-footer-left ${badgeClass}`}>
						<ul style={{ margin: 0, padding: 0 }}>
							<li>
								<a href="/">{statusText}</a>
							</li>
						</ul>
					</div>
				);
			},
		},

		{
			name: "ACTION",
			center: true,
			cell: (row) => { 
				
				const statusValue = hiringStatusvalue[row.cnddtId];
				const isDisabled = statusValue === 11; 

				return (
					<div>
                { 
				statusValue === 7 ||
				statusValue === 6 ||
				statusValue === 5 ||
				statusValue=== 8 ?
				"" : (
					
					<>			
						<span className="me-2">
							<Tooltip title="Reschedule" arrow>
								<CalendarMonthSharpIcon
									className={`pointer ${isDisabled ? "disabled-icon" : ""}`}
									onClick={
										isDisabled
											? undefined
											: () => {
												setShowAppliedModalScheule(true);
												setCandidateId(row.cnddtId);
												setCandData(row);
											}
									}
								/>
							</Tooltip>
						</span>

						<span className="me-2">
							<Tooltip title="Hire" arrow>
								<DoneIcon
									className={`pointer checkIcon ${isDisabled ? "disabled-icon" : ""
										}`}
									onClick={
										isDisabled
											? undefined
											: () => {
												setShowConfirmationModal(true);
												setApplicationStatus("Hired");
												setjobAppId(row.jbApplctnId);
												setCandidateId(row.cnddtId);
											}
									}
								/>
							</Tooltip>
						</span>

						<span className="me-2">
							<Tooltip title="Reject" arrow>
								<ClearSharpIcon
									className={`pointer rejectIcon ${isDisabled ? "disabled-icon" : ""
										}`}
									onClick={
										isDisabled
											? undefined
											: () => {
												setShowConfirmationModal(true);
												setApplicationStatus("Rejected");
												setjobAppId(row.jbApplctnId);
												setCandidateId(row.cnddtId);
											}
									}
								/>
							</Tooltip>
						</span>

						<span>
							<Tooltip title="Block" arrow>
								<BlockSharpIcon
									className={`pointer rejectIcon ${isDisabled ? "disabled-icon" : ""
										}`}
									onClick={
										isDisabled
											? undefined
											: () => {
												setShowConfirmationModal(true);
												setApplicationStatus("Blocked");
												setjobAppId(row.jbApplctnId);
												setCandidateId(row.cnddtId);
											}
									}
								/>
							</Tooltip>
						</span>

						<span className="ms-2">
							<Tooltip title="View Resume" arrow>
								<Link
									target="blank" 
									to={`/Resume?userUID=${instituteId}&InstUID=${row.instnCnddtID}`}
								>
									<VisibilitySharpIcon className="ViewIcon" />
								</Link>
							</Tooltip>
						</span>

						<span className="ms-2">
							<Tooltip title="Hold" arrow>
								<Link
									onClick={
										isDisabled
											? undefined
											: () => {
												HoldApplication(row.cnddtId);
												setjobAppId(row.jbApplctnId);
											}
									}
								>
									<PauseCircleOutlineIcon
										className={`blueIcon ${isDisabled ? "disabled-icon" : ""}`}
									/>
								</Link>
							</Tooltip>
						</span>

						<span className=" ">
							<Tooltip title="Test Assign" arrow>
								<Link
								>
									<AssignmentSharpIcon
										onClick={() => {
											handleTestShow()
										}}
										className="blueIcon" />
								</Link>
							</Tooltip>
						</span>
						</>
				)}

						{isDisabled && (
							<span className="ms-2">
								<Tooltip title="UnHold" arrow>
									<Link
										onClick={() => {
											UnHoldApplication(row.cnddtId);
											setjobAppId(row.jbApplctnId);
										}}
									>
										<PauseCircleFilledIcon className="blueIcon" />
									</Link>
								</Tooltip>
							</span>
						)}
					</div>
				);
			},
		},
	];


	const [display, setDisplay] = useState(false);
	const [search, setSearch] = useState("");
	const [InsCandidateList, setInsCandidateList] = useState([]);

	const getGetAllCandidate = async (page) => {
		const data = {
			pageNumber: page,
			pageSize: 10,
		};

		try {
			const response = await axios.post(
				`/Candidate/GetAllByInstt/${instituteId}?Type=${instituteAppData.grpTypName}&TypeId=${instituteAppData.grpTypeId}&Search=${search}`,
				data
			);
			const res = response.data.responseData.items;

			console.log("Candidate response:", res);
			setInsCandidateList(res);

			if (res.length > 0) {
				await Promise.all(
					res.map((candidate) => InstituteCandidateHiringStatus(candidate))
				);
			}

			setDisplay(false);
		} catch (e) {
			console.error("Error fetching candidates:", e);
			if (e.response && e.response.status === 404) {
				setDisplay(true);
			}
		}
	};

 
	const InstituteCandidateHiringStatus = async (candidate) => {
		if (!candidate || !candidate.cnddtId) {
			console.error("Invalid candidate data:", candidate);
			return;
		}
	
		try {
			const requestBody = {
				sessionId: sessionId,
				jbApplctnId: instituteAppData?.jbApplctnId,
				insttUid: instituteAppData?.userUid,
				cnddtID: candidate?.cnddtId,
				grpTypName: instituteAppData?.grpTypName,
				grpTypeId: instituteAppData?.grpTypeId,
			};
	
			console.log("req body", requestBody);
	
			const response = await axios.post(
				"/JobApplication/GetInstituteCandidateHiringStatus",
				requestBody
			);
	
			const hiringStatusName = response.data.responseData.hiringStatusName;
			const hiringStatusValue = response.data.responseData.hiringStatus;
	
			setHiringStatuses((prev) => ({
				...prev,
				[candidate.cnddtId]: hiringStatusName,
			}));
	
			setHiringStatusvalue((prev) => ({
				...prev,
				[candidate.cnddtId]: hiringStatusValue,
			}));
		} catch (error) {
			console.error("Error fetching hiring statuses:", error);
		}
	};
	
	useEffect(() => {
		if (instituteId || search) {
			getGetAllCandidate(); // Update candData
		}
	}, [instituteId, search]);
	
	useEffect(() => {
		if (candData && Array.isArray(candData)) {
			candData.forEach((candidate) => InstituteCandidateHiringStatus(candidate));
		}
	}, [candData]);
	
	return (
		<>
			<section className="pricing-section-three container jobapplication  pt-5">
				<div className="row">
					<div className="mb-1 col-md-6">
						<h4>
							<span className="orange-box me-2"></span>
							Recent Applications
						</h4>
					</div>
					<div className="mb-1 col-6 text-start"></div>
				</div>
				<div className="container st3">
					<div className="row">
						<div className="col-lg-12">
							<div className="table-res">
								<div className="react-dataTable">
									<DataTable
										noHeader
										pagination
										columns={columns}
										paginationPerPage={7}
										className="react-dataTable"
										sortIcon={<ChevronDown size={10} />}
										paginationDefaultPage={currentPage + 1}
										data={candidateList}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* UerInfo Modal */}
			<Modal
				show={showInstModal}
				onHide={handleCloseInstModal}
				centered
				size="lg"
			>
				<Modal.Header>
					<Modal.Title> Institute Candidate Details</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={() => {
							handleCloseInstModal();
							setInstituteId("");
							setInstituteAppData("");
						}}
					/>
				</Modal.Header>
				<Modal.Body className="settings jobapplication">
					<div className="container st3">
						<div className="row">
							<div className="col-lg-12">
								<div className="manage-search-bar">
									<SearchIcon className="icon" />
									<input
										type="text"
										placeholder="Search..."
										className="manage-search-input Dark-Manage-Search"
										onChange={(e) => setSearch(e.target.value)}
									/>
								</div>
								<div className="table-res">
									<div className="react-dataTable">
										<DataTable
											noHeader
											pagination
											columns={Inscolumns}
											paginationPerPage={7}
											className="react-dataTable"
											sortIcon={<ChevronDown size={10} />}
											paginationDefaultPage={currentPage + 1}
											data={InsCandidateList}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* UerInfo Modal */}
			{/* <Modal show={showUserInfo} onHide={handleCloseInfo} centered>
        <Modal.Header>
          <Modal.Title> Interview Details</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseInfo} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Col md={12}>
            <div className="post-form-group d-flex flex-row">
              <label htmlFor="about">
                <div> <h2>IMG</h2> </div>
              </label>
              <div className="px-2">
                <label htmlFor="schedule-time">
                  <h5>Ashh</h5>
                </label>
                <h6>FrontEnd Engineer</h6>
                <h6>React JS</h6>
              </div>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="schedule-time">
                Hiring Status :{" "}
                <span className="ms-2">{jobAppInfoData.hiringStatusName}</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Job Time:{" "}
                <span className="ms-2">{jobAppInfoData.typeName}</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Type: <span className="ms-2">{jobAppInfoData.rateType}</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Scheduled Time:{" "}
                <span className="ms-2">June 13 , 2024 , 05:30 am</span>
              </label>
            </div>
          </Col>

          <Col md={12}>
            <div className="post-form-group">
              <label htmlFor="about">
                Remark: <span className="ms-2"></span>
              </label>
            </div>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger apply-job me-2"
            onClick={handleCloseInfo}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>  */}

			{/* Modal */}
			<Modal show={showAppliedModal} onHide={handleCloseModal} centered>
				<Modal.Header>
					<Modal.Title>Add Interview Schedule Details</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Schedule Time{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<Flatpickr
								data-enable-time
								value={scheduleTime}
								onChange={(selectedDates) => {
									setScheduleTime(selectedDates[0]);
								}}
								options={{
									enableTime: true,
									dateFormat: "Y-m-d H:i",
								}}
								className="form-control Dark-Input-from-group"
								placeholder="Enter schedule time"
							/>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="schedule-time">
								Interview Mode Type{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<select
								id="place-type"
								value={placeType}
								onChange={(e) => setPlaceType(e.target.value)}
								className="form-control Dark-Input-from-group"
							>
								<option value="0"> Select </option>
								<option value="1">OnSite</option>
								<option value="2">Remote</option>
								<option value="3">Hybrid</option>
							</select>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Place Details{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<input
								type="text"
								value={placeDetails}
								onChange={(e) => setPlaceDetails(e.target.value)}
								placeholder="Enter place details"
								className="form-control Dark-Input-from-group"
							/>
						</div>
					</Col>

					<Col md={12}>
						<Form.Group controlId="description">
							<Form.Label>Remark</Form.Label>
							<Form.Control
								as="textarea"
								rows={3}
								value={remark}
								onChange={(e) => setRemark(e.target.value)}
								placeholder="Enter remark "
								className="Dark-Input-from-group"
							/>
						</Form.Group>
					</Col>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger apply-job me-2"
						onClick={ScheduleInterview}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

			{/* Interview schedule */}
			<Modal
				show={showAppliedModalScheule}
				onHide={handleCloseModalScheule}
				centered
			>
				<Modal.Header>
					<Modal.Title>Add Interview Schedule Details</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseModalScheule}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Schedule Time{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<Flatpickr
								data-enable-time
								value={scheduleTime}
								onChange={(selectedDates) => {
									setScheduleTime(selectedDates[0]);
								}}
								options={{
									enableTime: true,
									dateFormat: "Y-m-d H:i",
								}}
								className="form-control Dark-Input-from-group"
								placeholder="Enter schedule time"
							/>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="schedule-time">
								Interview Mode Type{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<select
								id="place-type"
								value={placeType}
								onChange={(e) => setPlaceType(e.target.value)}
								className="form-control Dark-Input-from-group"
							>
								<option value="0"> Select </option>
								<option value="1">OnSite</option>
								<option value="2">Remote</option>
								<option value="3">Hybrid</option>
							</select>
						</div>
					</Col>

					<Col md={12}>
						<div className="post-form-group">
							<label htmlFor="about">
								Place Details{" "}
								<span style={{ color: "red" }} className="ms-2">
									*
								</span>
							</label>
							<input
								type="text"
								value={placeDetails}
								onChange={(e) => setPlaceDetails(e.target.value)}
								placeholder="Enter place details"
								className="form-control Dark-Input-from-group"
							/>
						</div>
					</Col>

					<Col md={12}>
						<Form.Group controlId="description">
							<Form.Label>Remark</Form.Label>
							<Form.Control
								as="textarea"
								rows={3}
								className="Dark-Input-from-group"
								value={remark}
								onChange={(e) => setRemark(e.target.value)}
								placeholder="Enter remark"
							/>
						</Form.Group>
					</Col>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger apply-job me-2"
						onClick={ScheduleInterviewAsInst}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

			{/* Modal for Cancel Confirmation */}
			{/* <Modal show={showCancelModal} onHide={handleCloseCancelModal} centered>
        <Modal.Header>
          <Modal.Title>Cancel Confirmation</Modal.Title>
          <CloseSharpIcon
            className="pointer"
            onClick={handleCloseCancelModal}
          />
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to cancel this action?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => {
              RejectApplication();
            }}
          >
            Confirm Cancel
          </button>
        </Modal.Footer>
      </Modal> */}

			{/* Modal for Reject as institute Confirmation */}
			<Modal show={showRejectModal} onHide={handleCloseRejectModal} centered>
				<Modal.Header>
					<Modal.Title>Reject Confirmation</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseRejectModal}
					/>
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to Reject this Application?</p>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger"
						onClick={() => {
							RejectApplicationAsInst();
						}}
					>
						Confirm Cancel
					</button>
				</Modal.Footer>
			</Modal>

			<Modal show={showConfirmationModal} onHide={handleCancelConfirm} centered>
				<Modal.Header>
					<Modal.Title>Confirmation</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCancelConfirm} />
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to do ?</p>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-danger"
						onClick={() => {
							if (applicationStatus === "Hired") {
								AcceptInterviewApplicationAsInst(
									instituteAppData.jbApplctnId,
									"Hired"
								);
							} else if (applicationStatus === "Blocked") {
								AcceptInterviewApplicationAsInst(
									instituteAppData.jbApplctnId,
									"Blocked"
								);
							} else if (applicationStatus === "Rejected") {
								AcceptInterviewApplicationAsInst(
									instituteAppData.jbApplctnId,
									"Rejected"
								);
							} 
						}}
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>


			<Modal show={showtestModal} onHide={handleCloseTestModal} centered>
				<Modal.Header>
					<Modal.Title>Test Assign</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseTestModal} />
				</Modal.Header>
				<Modal.Body>
					{/* <div className="row ">
            
           
          </div> */}
					<div className="row  mt-2 align-center">
						<div className="col-md-8">
							<label htmlFor="about" className="f-14 f-700">
								Link
							</label>
							<input
								type="text"
								style={{ width: "100%" }}
								value={updateRemark}
								onChange={(e) => setUpdateRemark(e.target.value)}
							/>
						</div>
						<div className="col-md-4 mt-3">
							<span className="ms-2">
								<Tooltip title="Reschedule" arrow>

									<CalendarMonthSharpIcon
										className="pointer ViewIcon f-32" />
								</Tooltip>
							</span>
						</div>
					</div>
					<div className="row">

						<div className="col-md-12 mt-2">
							<label htmlFor="about" className="f-14 f-700">
								Instructions
							</label>
							<input
								type="text"
								style={{ width: "100%" }}
								value={updateRemark}
								onChange={(e) => setUpdateRemark(e.target.value)}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn khojPrimaryBtn"
						onClick={() => {
							// remarkUpdateFn();
						}}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

			{/*.................................... Assign test Modal end ................................*/}

			{/*.................................... History Job Modal Start ................................*/}

			<Modal show={showHistoryModal} onHide={handleCloseHistoryModal} centered>
				<Modal.Header>
					<Modal.Title> Job History</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseHistoryModal}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					{jobHistory && jobHistory.length > 0 ? (
						jobHistory.map(
							(data, index) => ( 
								(
									<div
										className="profile-resume-user-acvtivity mt-4"
										key={index}
									>
										<div className="d-flex justify-content-between">
											<div className="d-flex align-items-center">
												{data.hiringStatus === 5 && (
													<>
														<div className="profile-resume-applied-status me-2 profile-resume-cv-icon"></div>
														<div className="profile-resume-applied-jobs f-16 f-700 mb-2">
															Hiring Status Name: {data.hiringStatusName}
														</div>
													</>
												)}
												{data.hiringStatus === 4 && (
													<>
														<div className="profile-resume-applied-status me-2 profile-resume-success-icon"></div>
														<div className="profile-resume-applied-jobs f-16 f-700 mb-2">
															Hiring Status Name: {data.hiringStatusName}
														</div>
													</>
												)}
												{data.hiringStatus !== 5 && data.hiringStatus !== 4 && (
													<>
														<div className="profile-resume-applied-status me-2"></div>
														<div className="profile-resume-applied-jobs f-16 f-700 mb-2">
															Hiring Status Name: {data.hiringStatusName}
														</div>
													</>
												)}
											</div>

											{/* <div className="profile-resume-user-activity-time f-14 f-400 mb-1">
												{moment(data.time).format("HH : mm")} min ago
											</div> */}
										</div>

										<div className="profile-resume-user-actvity-container mb-3">
										{data.remark === "" ? '' : (

											<p className="f-14 f-400 mb-0">Remark :{data.remark}</p>
										)}
											<div className="profile-resume-pdf-cont d-flex">
												<div className="profile-resume-pdf-icon me-3">
													<img src={"/"} alt="" srcset="" />
												</div>
												<div className="profile-resume-pdf-text f-14 f-700 d-conntents ">
													<CalendarMonthSharpIcon className="me-1"/> Date :{" "}
													{moment(data.time).format("YYYY-MM-DD")}
												</div>
											</div>
										</div>
									</div>
								)
							)
						)
					) : (
						<p>No job history available.</p>
					)}
				</Modal.Body>

			</Modal>
			{/*.................................... history Job Modal End ................................*/}

			{/*.................................... Info Job Modal Start ................................*/}

			<Modal show={showInfoModal} onHide={handleCloseInfoModal} centered>
				<Modal.Header>
					<Modal.Title> Job Info</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseInfoModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						{jobInfo.grpName === "" ? '' : (
							<p>
								<span className="f-600">Group Name : </span>
								{jobInfo.grpName}
							</p>
						)}
						{jobInfo.grpTypName === "" ? "" : (
							<p>
								<span className="f-600">Group Type Name : </span>
								{jobInfo.grpTypName}
							</p>
						)}
						{jobInfo.hiringStatusName === null ? "" : (
							<p>
								<span className="f-600">Hiring Status Name : </span>
								{jobInfo.hiringStatusName}
							</p>
						)}
						{jobInfo.rateTypeName === null ? "" : (
							<p>
								<span className="f-600">Rate Type Name : </span>
								{jobInfo.rateTypeName}
							</p>
						)}
						{jobInfo.typeName === null ? "" : (
							<p>
								<span className="f-600">Type Name :</span> {jobInfo.typeName}
							</p>
						)}
					</div>
				</Modal.Body>
			</Modal>
			{/*.................................... Info Job Modal End ................................*/}
		</>
	);
};

export default RecentAplicants;
